import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "admin-console-page dash-board" }
const _hoisted_2 = { class: "console-page-head dash-head" }
const _hoisted_3 = { class: "console-desc" }
const _hoisted_4 = { class: "dash-grid" }
const _hoisted_5 = { class: "dash-col" }
const _hoisted_6 = { class: "console-panel dash-members" }
const _hoisted_7 = { class: "dash-panel-body" }
const _hoisted_8 = { class: "quick-find-field" }
const _hoisted_9 = {
  key: 0,
  class: "dash-empty"
}
const _hoisted_10 = {
  key: 1,
  class: "dash-empty"
}
const _hoisted_11 = { class: "quick-find-list" }
const _hoisted_12 = ["onClick", "onMouseenter"]
const _hoisted_13 = { class: "quick-find-name" }
const _hoisted_14 = { class: "quick-find-code" }
const _hoisted_15 = {
  key: 0,
  class: "console-panel quick-find"
}
const _hoisted_16 = { class: "dash-panel-body" }
const _hoisted_17 = { class: "quick-find-field" }
const _hoisted_18 = {
  key: 0,
  class: "dash-empty"
}
const _hoisted_19 = {
  key: 1,
  class: "dash-empty"
}
const _hoisted_20 = { class: "quick-find-list" }
const _hoisted_21 = ["onClick", "onMouseenter"]
const _hoisted_22 = { class: "quick-find-name" }
const _hoisted_23 = { class: "quick-find-code" }
const _hoisted_24 = {
  key: 1,
  class: "console-panel dash-notices"
}
const _hoisted_25 = { class: "dash-panel-body" }
const _hoisted_26 = {
  key: 0,
  class: "dash-empty"
}
const _hoisted_27 = {
  key: 1,
  class: "dash-empty"
}
const _hoisted_28 = {
  key: 2,
  class: "notice-list"
}
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 0,
  class: "notice-new"
}
const _hoisted_31 = {
  key: 1,
  class: "notice-pin"
}
const _hoisted_32 = { class: "notice-title" }
const _hoisted_33 = { class: "notice-meta" }
const _hoisted_34 = { class: "dash-col" }
const _hoisted_35 = {
  key: 0,
  class: "console-panel dash-notices"
}
const _hoisted_36 = { class: "dash-panel-body" }
const _hoisted_37 = {
  key: 0,
  class: "dash-empty"
}
const _hoisted_38 = {
  key: 1,
  class: "dash-empty"
}
const _hoisted_39 = {
  key: 2,
  class: "notice-list"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = {
  key: 0,
  class: "notice-new"
}
const _hoisted_42 = {
  key: 1,
  class: "notice-pin"
}
const _hoisted_43 = { class: "notice-title" }
const _hoisted_44 = { class: "notice-meta" }
const _hoisted_45 = {
  key: 1,
  class: "console-panel quick-find"
}
const _hoisted_46 = { class: "dash-panel-body" }
const _hoisted_47 = { class: "quick-find-field" }
const _hoisted_48 = {
  key: 0,
  class: "dash-empty"
}
const _hoisted_49 = {
  key: 1,
  class: "dash-empty"
}
const _hoisted_50 = { class: "quick-find-list" }
const _hoisted_51 = ["onClick", "onMouseenter"]
const _hoisted_52 = { class: "quick-find-name" }
const _hoisted_53 = { class: "quick-find-code" }
const _hoisted_54 = {
  key: 2,
  class: "console-panel dash-consult"
}
const _hoisted_55 = { class: "dash-panel-body" }
const _hoisted_56 = {
  key: 0,
  class: "dash-empty"
}
const _hoisted_57 = {
  key: 1,
  class: "dash-empty"
}
const _hoisted_58 = {
  key: 2,
  class: "consult-list"
}
const _hoisted_59 = { class: "consult-body" }
const _hoisted_60 = { class: "consult-title" }
const _hoisted_61 = {
  key: 0,
  class: "consult-org"
}
const _hoisted_62 = { class: "notice-read-head" }
const _hoisted_63 = { class: "notice-read-head-text" }
const _hoisted_64 = { class: "notice-read-title" }
const _hoisted_65 = {
  key: 0,
  class: "notice-new"
}
const _hoisted_66 = { class: "notice-read-meta" }
const _hoisted_67 = { class: "notice-read-actions" }

import { computed, onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { boardApi, consultBoardApi, crawlApi, memberApi } from '@/services/api';
import BoardBody from '@/components/admin/BoardBody.vue';
import DashCalendar from '@/components/admin/DashCalendar.vue';

interface NoticeItem {
  idx: number;
  title: string;
  body: string;
  pinned: boolean;
  authorName: string;
  createdAt: string | null;
}

interface MemberHit {
  m_idx: number;
  m_code: string;
  m_name: string;
  m_longterm_code: string;
}

interface FacilityHit {
  cc_number: string;
  cc_name: string;
}

interface ConsultHit {
  id: number;
  title: string;
  orgName: string;
  status: string;
}

const NEW_NOTICE_MS = 7 * 24 * 60 * 60 * 1000;


export default /*@__PURE__*/_defineComponent({
  __name: 'AdminDashboardPage',
  setup(__props) {

const router = useRouter();
const store = useStore();

const isManagerAdmin = computed(() => Number(store.getters.roleLevel || 0) >= 80);

const notices = ref<NoticeItem[]>([]);
const noticeLoading = ref(false);
const detailOpen = ref(false);
const selected = ref<NoticeItem | null>(null);

const now = new Date();

const recentMembers = ref<MemberHit[]>([]);
const memberLoading = ref(false);
const memberKeyword = ref('');
const memberResults = ref<MemberHit[]>([]);
const memberTotal = ref(0);
const memberSearching = ref(false);
const memberActive = ref(0);
const memberBusy = computed(() => (memberKeyword.value.trim() ? memberSearching.value : memberLoading.value));
const memberVisible = computed(() => (memberKeyword.value.trim() ? memberResults.value.slice(0, 5) : recentMembers.value));
const memberHasMore = computed(() => !!memberKeyword.value.trim() && memberTotal.value > 5);

const facilityKeyword = ref('');
const facilityResults = ref<FacilityHit[]>([]);
const facilityTotal = ref(0);
const facilitySearching = ref(false);
const facilityActive = ref(0);
const facilityVisible = computed(() => facilityResults.value.slice(0, 5));
const facilityHasMore = computed(() => facilityTotal.value > 5);

const consults = ref<ConsultHit[]>([]);
const consultLoading = ref(false);

let facilityTimer: ReturnType<typeof setTimeout> | null = null;
let facilitySeq = 0;
let memberTimer: ReturnType<typeof setTimeout> | null = null;
let memberSeq = 0;

const todayLabel = computed(() => {
  const days = ['일', '월', '화', '수', '목', '금', '토'];
  return `${now.getFullYear()}년 ${now.getMonth() + 1}월 ${now.getDate()}일 ${days[now.getDay()]}요일`;
});

const isNewNotice = (createdAt: string | null) => {
  if (!createdAt) return false;
  const posted = new Date(String(createdAt).replace(' ', 'T'));
  if (Number.isNaN(posted.getTime())) return false;
  const age = Date.now() - posted.getTime();
  return age >= 0 && age < NEW_NOTICE_MS;
};

const formatDate = (value: string | null) => (value ? String(value).substring(0, 10) : '');

const formatDateTime = (value: string | null) =>
  value ? String(value).substring(0, 16).replace('T', ' ') : '';

const loadNotices = async () => {
  noticeLoading.value = true;
  try {
    const res = await boardApi.notices();
    notices.value = (res.data?.data?.items || []).slice(0, 6);
  } catch (error) {
    notices.value = [];
  } finally {
    noticeLoading.value = false;
  }
};

const mapConsult = (row: ConsultHit): ConsultHit => ({
  id: row.id,
  title: row.title,
  orgName: row.orgName,
  status: row.status,
});

const loadConsults = async () => {
  if (!isManagerAdmin.value) return;
  consultLoading.value = true;
  try {
    const preview = 5;
    const waitingRes = await consultBoardApi.listRequests({ page: 1, limit: 10, status: 'WAIT' });
    const waiting = (waitingRes.data?.data?.items || []).slice(0, preview).map(mapConsult);
    let done: ConsultHit[] = [];
    if (waiting.length < preview) {
      const doneRes = await consultBoardApi.listRequests({ page: 1, limit: 10, status: 'DONE' });
      done = (doneRes.data?.data?.items || []).slice(0, preview - waiting.length).map(mapConsult);
    }
    consults.value = [...waiting, ...done];
  } catch (error) {
    consults.value = [];
  } finally {
    consultLoading.value = false;
  }
};

const loadRecentMembers = async () => {
  memberLoading.value = true;
  try {
    const res = await memberApi.getList({ sort: 'recent', page: 1, limit: 5 });
    const rows = Array.isArray(res.data?.data) ? res.data.data : [];
    recentMembers.value = rows.map((row: MemberHit) => ({
      m_idx: row.m_idx,
      m_code: row.m_code,
      m_name: row.m_name,
      m_longterm_code: row.m_longterm_code,
    }));
  } catch (error) {
    recentMembers.value = [];
  } finally {
    memberLoading.value = false;
  }
};

const searchMembers = async (text: string) => {
  const seq = ++memberSeq;
  memberSearching.value = true;
  try {
    const res = await memberApi.getList({ search: text, page: 1, limit: 5 });
    if (seq !== memberSeq) return;
    const rows = Array.isArray(res.data?.data) ? res.data.data : [];
    memberResults.value = rows.slice(0, 5).map((row: MemberHit) => ({
      m_idx: row.m_idx,
      m_code: row.m_code,
      m_name: row.m_name,
      m_longterm_code: row.m_longterm_code,
    }));
    memberTotal.value = Number(res.data?.pagination?.total ?? rows.length);
    memberActive.value = 0;
  } catch (error) {
    if (seq !== memberSeq) return;
    memberResults.value = [];
    memberTotal.value = 0;
  } finally {
    if (seq === memberSeq) memberSearching.value = false;
  }
};

const searchFacilities = async (text: string) => {
  const seq = ++facilitySeq;
  facilitySearching.value = true;
  try {
    const res = await crawlApi.getList({ search: text, page: 1, limit: 5 });
    if (seq !== facilitySeq) return;
    const rows = Array.isArray(res.data?.data) ? res.data.data : [];
    facilityResults.value = rows.slice(0, 5).map((row: FacilityHit) => ({
      cc_number: row.cc_number,
      cc_name: row.cc_name,
    }));
    facilityTotal.value = Number(res.data?.pagination?.total ?? rows.length);
    facilityActive.value = 0;
  } catch (error) {
    if (seq !== facilitySeq) return;
    facilityResults.value = [];
    facilityTotal.value = 0;
  } finally {
    if (seq === facilitySeq) facilitySearching.value = false;
  }
};

const openMember = (item: MemberHit) => {
  const height = window.screen.height;
  window.open(
    `/member/detail/${item.m_code}`,
    'memberDetailPopup',
    `width=2000,height=${height},left=0,top=0,scrollbars=yes,resizable=yes`
  );
};

const openFacility = (item: FacilityHit) => {
  window.open(
    `/facility/detail/${item.cc_number}`,
    'facilityDetailPopup',
    'width=1100,height=720,left=0,top=0,menubar=no,toolbar=no,location=yes,status=no,resizable=yes,scrollbars=yes'
  );
};

const bindSearchKey = (
  event: KeyboardEvent,
  results: { value: unknown[] },
  active: { value: number },
  open: (item: any) => void
) => {
  if (event.key === 'ArrowDown' && results.value.length) {
    event.preventDefault();
    active.value = (active.value + 1) % results.value.length;
  } else if (event.key === 'ArrowUp' && results.value.length) {
    event.preventDefault();
    active.value = (active.value - 1 + results.value.length) % results.value.length;
  } else if (event.key === 'Enter') {
    const hit = results.value[active.value];
    if (hit) open(hit);
  }
};

const onFacilityKey = (event: KeyboardEvent) => {
  bindSearchKey(event, facilityVisible, facilityActive, openFacility);
};

const onMemberKey = (event: KeyboardEvent) => {
  if (!memberKeyword.value.trim()) return;
  bindSearchKey(event, memberVisible, memberActive, openMember);
};

watch(memberKeyword, (value) => {
  if (memberTimer) clearTimeout(memberTimer);
  const text = value.trim();
  if (!text) {
    memberSeq += 1;
    memberResults.value = [];
    memberTotal.value = 0;
    memberSearching.value = false;
    memberActive.value = 0;
    return;
  }
  memberTimer = setTimeout(() => searchMembers(text), 180);
});

watch(facilityKeyword, (value) => {
  if (facilityTimer) clearTimeout(facilityTimer);
  const text = value.trim();
  if (!text) {
    facilitySeq += 1;
    facilityResults.value = [];
    facilityTotal.value = 0;
    facilitySearching.value = false;
    return;
  }
  facilityTimer = setTimeout(() => searchFacilities(text), 180);
});

const openNotice = (item: NoticeItem) => {
  selected.value = item;
  detailOpen.value = true;
};

const goNotice = () => router.push('/board');
const goMember = () => router.push('/member');
const goMemberMore = () => {
  const search = memberKeyword.value.trim();
  router.push(search ? { path: '/member', query: { search } } : '/member');
};
const goFacility = () => router.push('/facility');
const goFacilityMore = () => {
  const search = facilityKeyword.value.trim();
  router.push(search ? { path: '/facility', query: { search } } : '/facility');
};
const goConsult = () => router.push('/consult-requests');

onMounted(() => {
  loadRecentMembers();
  loadNotices();
  loadConsults();
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _cache[6] || (_cache[6] = _createElementVNode("h2", { class: "console-title" }, "대시보드", -1)),
      _createElementVNode("p", _hoisted_3, _toDisplayString(todayLabel.value), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("section", _hoisted_6, [
          _createElementVNode("div", { class: "console-panel-head" }, [
            _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "console-panel-title" }, "고객관리", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "console-text-btn",
              "aria-label": "고객관리로 이동",
              onClick: goMember
            }, "이동")
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, [
              _createVNode(_component_v_icon, { size: "18" }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("mdi-magnify", -1)
                ]))]),
                _: 1
              }),
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((memberKeyword).value = $event)),
                type: "text",
                placeholder: "시설명, 기관기호",
                onKeydown: onMemberKey
              }, null, 544), [
                [_vModelText, memberKeyword.value]
              ])
            ]),
            (memberBusy.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(memberKeyword.value.trim() ? '찾는 중' : '불러오는 중'), 1))
              : (!memberVisible.value.length)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, "데이터가 없습니다"))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("ul", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(memberVisible.value, (item, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: item.m_idx
                        }, [
                          _createElementVNode("button", {
                            type: "button",
                            class: _normalizeClass(["quick-find-row", { 'is-active': !!memberKeyword.value.trim() && index === memberActive.value }]),
                            onClick: ($event: any) => (openMember(item)),
                            onMouseenter: ($event: any) => (memberActive.value = index)
                          }, [
                            _createElementVNode("span", _hoisted_13, _toDisplayString(item.m_name), 1),
                            _createElementVNode("span", _hoisted_14, _toDisplayString(item.m_longterm_code || '—'), 1)
                          ], 42, _hoisted_12)
                        ]))
                      }), 128))
                    ]),
                    (memberHasMore.value)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          type: "button",
                          class: "dash-more",
                          onClick: goMemberMore
                        }, "더보기"))
                      : _createCommentVNode("", true)
                  ], 64))
          ])
        ]),
        (!isManagerAdmin.value)
          ? (_openBlock(), _createElementBlock("section", _hoisted_15, [
              _createElementVNode("div", { class: "console-panel-head" }, [
                _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "console-panel-title" }, "시설검색", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "console-text-btn",
                  "aria-label": "시설검색으로 이동",
                  onClick: goFacility
                }, "이동")
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                      _createTextVNode("mdi-magnify", -1)
                    ]))]),
                    _: 1
                  }),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((facilityKeyword).value = $event)),
                    type: "text",
                    placeholder: "시설명, 기관기호",
                    onKeydown: onFacilityKey
                  }, null, 544), [
                    [_vModelText, facilityKeyword.value]
                  ])
                ]),
                (facilitySearching.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_18, "찾는 중"))
                  : (!facilityVisible.value.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_19, "데이터가 없습니다"))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("ul", _hoisted_20, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(facilityVisible.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: item.cc_number
                            }, [
                              _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(["quick-find-row", { 'is-active': index === facilityActive.value }]),
                                onClick: ($event: any) => (openFacility(item)),
                                onMouseenter: ($event: any) => (facilityActive.value = index)
                              }, [
                                _createElementVNode("span", _hoisted_22, _toDisplayString(item.cc_name), 1),
                                _createElementVNode("span", _hoisted_23, _toDisplayString(item.cc_number || '—'), 1)
                              ], 42, _hoisted_21)
                            ]))
                          }), 128))
                        ]),
                        (facilityHasMore.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "dash-more",
                              onClick: goFacilityMore
                            }, "더보기"))
                          : _createCommentVNode("", true)
                      ], 64))
              ])
            ]))
          : _createCommentVNode("", true),
        (isManagerAdmin.value)
          ? (_openBlock(), _createElementBlock("section", _hoisted_24, [
              _createElementVNode("div", { class: "console-panel-head" }, [
                _cache[11] || (_cache[11] = _createElementVNode("h3", { class: "console-panel-title" }, "공지사항", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "console-text-btn",
                  "aria-label": "게시판으로 이동",
                  onClick: goNotice
                }, "이동")
              ]),
              _createElementVNode("div", _hoisted_25, [
                (noticeLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_26, "불러오는 중"))
                  : (!notices.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, "데이터가 없습니다"))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_28, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notices.value, (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: item.idx
                          }, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "notice-row",
                              onClick: ($event: any) => (openNotice(item))
                            }, [
                              (isNewNotice(item.createdAt))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_30, "신규"))
                                : _createCommentVNode("", true),
                              (item.pinned)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, "고정"))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_32, _toDisplayString(item.title), 1),
                              _createElementVNode("span", _hoisted_33, _toDisplayString(formatDate(item.createdAt)), 1)
                            ], 8, _hoisted_29)
                          ]))
                        }), 128))
                      ]))
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_34, [
        (!isManagerAdmin.value)
          ? (_openBlock(), _createElementBlock("section", _hoisted_35, [
              _createElementVNode("div", { class: "console-panel-head" }, [
                _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "console-panel-title" }, "공지사항", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "console-text-btn",
                  "aria-label": "게시판으로 이동",
                  onClick: goNotice
                }, "이동")
              ]),
              _createElementVNode("div", _hoisted_36, [
                (noticeLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, "불러오는 중"))
                  : (!notices.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, "데이터가 없습니다"))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_39, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notices.value, (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: item.idx
                          }, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "notice-row",
                              onClick: ($event: any) => (openNotice(item))
                            }, [
                              (isNewNotice(item.createdAt))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_41, "신규"))
                                : _createCommentVNode("", true),
                              (item.pinned)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_42, "고정"))
                                : _createCommentVNode("", true),
                              _createElementVNode("span", _hoisted_43, _toDisplayString(item.title), 1),
                              _createElementVNode("span", _hoisted_44, _toDisplayString(formatDate(item.createdAt)), 1)
                            ], 8, _hoisted_40)
                          ]))
                        }), 128))
                      ]))
              ])
            ]))
          : _createCommentVNode("", true),
        (isManagerAdmin.value)
          ? (_openBlock(), _createElementBlock("section", _hoisted_45, [
              _createElementVNode("div", { class: "console-panel-head" }, [
                _cache[13] || (_cache[13] = _createElementVNode("h3", { class: "console-panel-title" }, "시설검색", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "console-text-btn",
                  "aria-label": "시설검색으로 이동",
                  onClick: goFacility
                }, "이동")
              ]),
              _createElementVNode("div", _hoisted_46, [
                _createElementVNode("label", _hoisted_47, [
                  _createVNode(_component_v_icon, { size: "18" }, {
                    default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                      _createTextVNode("mdi-magnify", -1)
                    ]))]),
                    _: 1
                  }),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((facilityKeyword).value = $event)),
                    type: "text",
                    placeholder: "시설명, 기관기호",
                    onKeydown: onFacilityKey
                  }, null, 544), [
                    [_vModelText, facilityKeyword.value]
                  ])
                ]),
                (facilitySearching.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_48, "찾는 중"))
                  : (!facilityVisible.value.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_49, "데이터가 없습니다"))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        _createElementVNode("ul", _hoisted_50, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(facilityVisible.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: item.cc_number
                            }, [
                              _createElementVNode("button", {
                                type: "button",
                                class: _normalizeClass(["quick-find-row", { 'is-active': index === facilityActive.value }]),
                                onClick: ($event: any) => (openFacility(item)),
                                onMouseenter: ($event: any) => (facilityActive.value = index)
                              }, [
                                _createElementVNode("span", _hoisted_52, _toDisplayString(item.cc_name), 1),
                                _createElementVNode("span", _hoisted_53, _toDisplayString(item.cc_number || '—'), 1)
                              ], 42, _hoisted_51)
                            ]))
                          }), 128))
                        ]),
                        (facilityHasMore.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "dash-more",
                              onClick: goFacilityMore
                            }, "더보기"))
                          : _createCommentVNode("", true)
                      ], 64))
              ])
            ]))
          : _createCommentVNode("", true),
        (isManagerAdmin.value)
          ? (_openBlock(), _createElementBlock("section", _hoisted_54, [
              _createElementVNode("div", { class: "console-panel-head" }, [
                _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "console-panel-title" }, "상담요청", -1)),
                _createElementVNode("button", {
                  type: "button",
                  class: "console-text-btn",
                  "aria-label": "상담요청으로 이동",
                  onClick: goConsult
                }, "이동")
              ]),
              _createElementVNode("div", _hoisted_55, [
                (consultLoading.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_56, "불러오는 중"))
                  : (!consults.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, "데이터가 없습니다"))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_58, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(consults.value, (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: item.id
                          }, [
                            _createElementVNode("button", {
                              type: "button",
                              class: "consult-row",
                              onClick: goConsult
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["consult-state", item.status === 'DONE' ? 'is-done' : 'is-wait'])
                              }, _toDisplayString(item.status === 'DONE' ? '완료' : '대기'), 3),
                              _createElementVNode("span", _hoisted_59, [
                                _createElementVNode("span", _hoisted_60, _toDisplayString(item.title), 1),
                                (item.orgName)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(item.orgName), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]))
                        }), 128))
                      ]))
              ])
            ]))
          : _createCommentVNode("", true),
        (!isManagerAdmin.value)
          ? (_openBlock(), _createBlock(DashCalendar, { key: 3 }))
          : _createCommentVNode("", true)
      ]),
      (isManagerAdmin.value)
        ? (_openBlock(), _createBlock(DashCalendar, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: detailOpen.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((detailOpen).value = $event)),
      "max-width": "560"
    }, {
      default: _withCtx(() => [
        (selected.value)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: 0,
              class: "notice-read-card"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("div", _hoisted_63, [
                    _cache[16] || (_cache[16] = _createElementVNode("p", { class: "console-kicker" }, "공지", -1)),
                    _createElementVNode("h3", _hoisted_64, [
                      (isNewNotice(selected.value.createdAt))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_65, "신규"))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(selected.value.title), 1)
                    ]),
                    _createElementVNode("p", _hoisted_66, _toDisplayString(selected.value.authorName || '관리자') + " · " + _toDisplayString(formatDateTime(selected.value.createdAt)), 1)
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "notice-read-card__close",
                    "aria-label": "닫기",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (detailOpen.value = false))
                  }, [
                    _createVNode(_component_v_icon, { size: "18" }, {
                      default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                        _createTextVNode("mdi-close", -1)
                      ]))]),
                      _: 1
                    })
                  ])
                ]),
                _createVNode(BoardBody, {
                  class: "notice-read-body",
                  body: selected.value.body
                }, null, 8, ["body"]),
                _createElementVNode("div", _hoisted_67, [
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    class: "btn-close",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (detailOpen.value = false))
                  }, {
                    default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                      _createTextVNode("닫기", -1)
                    ]))]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})